<tt-page *ngIf="!!get">
    <tt-page-heading ttModel="p2_m_productsoverview" ttTranslate></tt-page-heading>
    <tt-card class="col-xs-12 col-md-3 sp-0">
        <form (ngSubmit)="readGrid()">
            <tt-input ttRememberId="w_productsoverview.searchtext" ttLabel="searchtext" [(ttModel)]="get.searchtext" [ttButtons]="searchButtons" ttShowClearButton></tt-input>
            <tt-button-goto ttText="productsearch_new_product" ttIcon="far fa-plus" ttGoto="productcreate" [ttGotoParms]="{ argtype: '-', argvalue: '-' }"></tt-button-goto>
        </form>
    </tt-card>
    <div class="flex-1">
        <tt-grid *ngIf="!!grid" class="height-full" [(ttOptions)]="grid"></tt-grid>
    </div>
    <tt-card *ngIf="get.showsettings === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
